import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Search } from 'lucide-react';
import { MdPrint } from "react-icons/md";
import classes from "./AdminViewAsset.module.css";
// import plus from "../../../../Assets/plus.svg"
import { FaEdit, FaPen } from 'react-icons/fa';
// import DeleteIcon from "../../../../Assets/new-delete.svg"
import { Spinner, Badge, Button, Modal, Form, Alert, Table } from 'react-bootstrap';
import HeaderNav from "../../Accoungting/HeaderNav/FixedAssetNav";
import axios from "axios";
import { BASE_URL, TOKEN, BASE_URL1 } from "../../../Components/Styles/API/API";
// "../../../../Components/Styles/API/API";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { Pencil } from "lucide-react";
import CurrencyInput from 'react-currency-input-field';
// import ToggleSlider from "./ToggleSlider";
import Pic from '../../../Assets/img.png'
import Pdf from '../../../Assets/pdf.png'

const AdminViewAsset = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedAsset } = location.state || {};
  const [searchTerm, setSearchTerm] = useState("");
  // const { parishID } = location.state || {};
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [error, setError] = useState("");
  const [modalError, setModalError] = useState("");
  const [success, setSuccess] = useState("");
  const [bearer, setBearer] = useState('');
 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalUsers, setTotalUsers] = useState(0);
  const [selectedType, setSelectedType] = useState("");
  const [fullName, setFullName] = useState("");
  const [fullName1, setFullName1] = useState("");
  const [email, setEmail] = useState("");
  const [email1, setEmail1] = useState("");
  const [phone1, setPhone1] = useState("");
  const [selectedRole1, setSelectedRole1] = useState("");
  const [phone, setPhone] = useState("");
  const [description, setDescription] = useState("");
  const [userType, setUserType] = useState([]);
  const [zones, setZones] = useState([]);

  // Main filter states
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [provLoading, setProvLoading] = useState(false);

  // React Select states for filters
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [contLoading, setContLoading] = useState(false);
  const [regionLoading, setRegionLoading] = useState(false);

  // React Select states for modal
  const [selectedContinentModal, setSelectedContinentModal] = useState(null);
  const [regionsModal, setRegionsModal] = useState([]);
  const [provincesModal, setProvincesModal] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [totalEntries, setTotalEntries] = useState("");
  // const [totalPages, setTotalPages] = useState(1);
  const [areas, setAreas] = useState([]);


  const [selectedZone, setSelectedZone] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [continentName, setContinentName] = useState(null);
  const [continentID, setContinentID] = useState(null);
  const [regionID, setRegionID] = useState(null);
  const [regionName, setRegionName] = useState(null);
  const [provinceID, setProvinceID] = useState(null);
  const [provinceName, setProvinceName] = useState(null);

  const [approvalLoading, setApprovalLoading] = useState(false);
  const [disApprovalLoading, setDisapprovalLoading] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);


  // Get token from localStorage
  const readData = async () => {
    try {
      const value = await localStorage.getItem('userToken');
      const value4 = await localStorage.getItem('provinceID');
      const value5 = await localStorage.getItem('regionID');
      const value6 = await localStorage.getItem('continentID');
      const conName = await localStorage.getItem('continent');
      const proName = await localStorage.getItem('province');
      const regName = await localStorage.getItem('region');

      if (value !== null) {
        setBearer(value);
      }
      if (value4 !== null) {
        setProvinceID(value4);
      }
      if (value5 !== null) {
        setRegionID(value5);
      }
      if (value6 !== null) {
        setContinentID(value6);
      }
      if (conName !== null) {
        setContinentName(conName);
      }
      if (proName !== null) {
        setProvinceName(proName);
      }
      if (regName !== null) {
        setRegionName(regName);
      }
    } catch (e) {
      console.error('Failed to fetch token from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  const goBack = () => {
    navigate(-1);
  }
 
  



  // Fetch continents for React Select
  const fetchContinents = async () => {
    setContLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const contList = response.data?.data;
      const options = contList.map((item) => ({
        label: item.description,
        value: item.id,
      }));

      const continentsWithAll = [
        { label: "All Continents", value: "all" },
        ...options
      ];

      setContinents(continentsWithAll);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching continents:", error);
        setContinents([{ label: "All Continents", value: "all" }]);
      }
    } finally {
      setContLoading(false);
    }
  };

  

  // Auto-fetch users when filters change
  useEffect(() => {
    if (bearer) {
      setCurrentPage(1);
      // fetchUsers(1);
    }
  }, [selectedContinent, selectedRegion, selectedProvince, bearer]);

  // Fetch user types for dropdown
  const fetchData1 = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/all-usertype`, { headers });
      const typeList = response.data?.data;
      setUserType(typeList);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        console.error("Error fetching user types:", error);
        setUserType([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      // fetchUsers(currentPage);
      fetchData1();
      fetchContinents();
      setRegions([{ label: "All Regions", value: "all" }]);
    }
  }, [bearer]);




  // React Select styles
  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: '100%',
      fontSize: 12,
    }),
    control: (provided) => ({
      ...provided,
      minHeight: "36px",
      fontSize: 12,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: 12,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: 12,
      backgroundColor: state.isFocused ? "#f1f5f9" : "white",
      color: "#111827",
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: "300px",
      overflowY: "auto",
      fontSize: 12,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const formattedDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())} ${date.getHours() >= 12 ? 'PM' : 'AM'}`;
    return formattedDate;
  }

  function padZero(num) {
    return num < 10 ? `0${num}` : num;
  }



  return (
    <div>
      <HeaderNav />

      {/* Main Content */}
      <div className={classes.topContainer}>

        <div style={{ marginTop: 30 }} />
        <h3 className={classes.topText}>{selectedAsset?.parish?.description}</h3>
        {/* <p className={classes.prgText}>View All Parish.</p> */}

        <Form style={{ marginTop: 20, width: '90%' }}>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Identification Number</Form.Label>
                        <div style={{ width: 500 }}>
                        <Form.Control
          className="formControl" 
          type="text"
          style={{fontSize: "12px"}}
          value={selectedAsset?.identification_number}
          disabled
        />
                      </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <div className="d-flex align-items-center form-group-custom">
                      <Form.Label className={classes.formLabelCustom122}>Asset Name</Form.Label>
                      <div style={{ width: 500 }}>
                      <Form.Control
          className="formControl" 
          type="text"
          style={{fontSize: "12px"}}
          value={selectedAsset?.description}
          disabled
        />
                      </div>
                      
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Category</Form.Label>
                        <div style={{ width: 500, display: "flex", flexDirection: "column" }}>
                        <Form.Control
          className="formControl" 
          type="text"
          style={{fontSize: "12px"}}
          value={selectedAsset?.asset_category?.description}
          disabled
        />
                        </div>
                      </div>
                    </Form.Group>
                       
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Amount Purchased</Form.Label>
                        <CurrencyInput
                  name={`amount purchased`}
                  decimalsLimit={2}
                  // style={{fontSize: "12px"}}
                  value={selectedAsset?.amount_purchased}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />
                      </div>
                    </Form.Group>
                  </div>
                </div>
                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Proceed on Sale</Form.Label>
                        <CurrencyInput
                  name={`amount sold`}
                  decimalsLimit={2}
                  value={selectedAsset?.proceed_on_sale}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Date Purchased</Form.Label>
                        <Form.Control
                              type="date"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.date_purchased}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Date Disposed</Form.Label>
                        <Form.Control
                              type="date"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.date_disposed}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Lifetime in years</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.lifetime_in_years}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Model Number</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.model_number}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Serial Number</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.serial_number}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Quantity</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.quantity}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Unit Price</Form.Label>
                        <CurrencyInput
                  name={`amount sold`}
                  decimalsLimit={2}
                  value={selectedAsset?.unit_price}
                  className="form-control"
                  // style={{fontSize: "12px"}}
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Location</Form.Label>
                        <Form.Control
                              type="text"
                              style={{fontSize: "12px"}}
                              value={selectedAsset?.location}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Residual Value</Form.Label>
                        <CurrencyInput
                  name={`amount sold`}
                  decimalsLimit={2}
                  value={selectedAsset?.residual_value}
                  className="form-control"
                  disabled
                  style={{ textAlign: "right", border: "none", width: '100%', fontSize: "12px" }}
                />

                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="row" style={{ marginTop: 5 }}>

                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Supporting Document</Form.Label>
                        <Form.Control
                              type="file"
                              // value={selectedAsset?.location}
                              style={{fontSize: "12px"}}
                          disabled
                            />
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group className="mb-3">
                      <div className="d-flex align-items-center form-group-custom">
                        <Form.Label className={classes.formLabelCustom122}>Remarks</Form.Label>
                        <Form.Control
                              type="text"
                              value={selectedAsset?.remarks}
                              style={{fontSize: "12px"}}
                          disabled
                            />

                      </div>
                    </Form.Group>
                  </div>
                </div>
                
               
       
      </Form>

        <div style={{ marginTop: 24 }} />

        <div className={classes.buttonsGroup}>
   <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
   <div className="row" style={{maxWidth: "100%", marginTop: 30}}>
      <h5 style={{ textAlign: "left" }}>Document(s) Uploaded</h5>
      {selectedAsset?.documents && selectedAsset?.documents?.length > 0 ? (
                                                            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                                              {selectedAsset.documents.map((document, index) => (
                                                                <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '20px', textAlign: 'center' }}>
                                                                  {document.pdf_file.toLowerCase().endsWith('.pdf') ? (
                                                                    <span title={document.pdf_file}>
                                                                      <img src={Pdf} alt="PDF Icon" style={{ width: '100px', height: '100px', cursor: 'pointer' }} onClick={() => window.open(document.pdf_file, '_blank')} />
                                                                      <div style={{ marginTop: '5px' }}>
                                                                        {document.pdf_file.length > 20 ? `${document.pdf_file.substring(0, 20)}...` : document.pdf_file}
                                                                      </div>
                                                                    </span>
                                                                  ) : (
                                                                    <span title={document.pdf_file}>
                                                                      <img src={Pic} alt="Document" style={{ width: '100px', height: '100px', cursor: 'pointer' }} onClick={() => window.open(document.pdf_file, '_blank')} />
                                                                      <div style={{ marginTop: '5px' }}>
                                                                        {document.pdf_file.length > 20 ? `${document.pdf_file.substring(0, 20)}...` : document.pdf_file}
                                                                      </div>
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              ))}
                                                            </div>
                                                          ) : (
                                                            <p>No document uploaded</p>
                                                          )}

                  
                </div>
            </div>
          

            <div style={{marginTop: 50}} className={classes.bttn}>
              <Button variant="light" className={classes.btn1} onClick={goBack}> Cancel</Button>
              {/* {selectedAsset?.approval_status === "1" && (
    <>
              <Button  style={{ borderRadius: 5 }} variant='success' onClick={handleApprove}>
                {approvalLoading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                            </>
                          ) : (
                            "Approve"
                          )}
             
              </Button>
              <Button  style={{ borderRadius: 5 }} variant='danger' onClick={handleDisApprove}>
                {disApprovalLoading ? (
                            <>
                              <Spinner size='sm' />
                              <span style={{ marginLeft: '5px' }}>Processing, Please wait...</span>
                            </>
                          ) : (
                            "Disapprove"
                          )}
                
              </Button>
              </>
)} */}
            </div>
          </div>


       
      </div>
    </div>
  )
}

export default AdminViewAsset;